import React from 'react';

type SkeletonAnimation = 'pulse' | 'wave' | 'none';

interface SkeletonTableProps {
  rows?: number;
  columns?: number;
  hasHeader?: boolean;
  animation?: SkeletonAnimation;
  hasExtraInfo?: boolean; // Show/hide the top info section (title, filters, actions)
  filterCount?: number; // Number of filter/search placeholders in the extra info section
  hasActionButton?: boolean; // Show/hide the top-right action button (e.g. "Invite Users")
}

export const SkeletonTable: React.FC<SkeletonTableProps> = ({
  rows = 5,
  columns = 4,
  hasHeader = true,
  animation = 'wave',
  hasExtraInfo = false,
  filterCount = 3,
  hasActionButton = true,
}) => {
  const columnIndexes = Array.from({ length: columns });
  const rowIndexes = Array.from({ length: rows });
  const filterIndexes = Array.from({ length: filterCount });

  return (
    <div className="skeleton-table-wrapper">
      {hasExtraInfo && (
        <>
            <div className="skeleton-table-extra-info">
            <div className="skeleton-table-extra-info-top">
                <div className="line skeleton-table-title" />
                {hasActionButton && <div className="line skeleton-table-action-button" />}
            </div>
            <div className="line skeleton-table-subtitle" />
            <div className="skeleton-table-filters">
                {filterIndexes.map((_, index) => (
                <div key={`filter-${index}`} className="line skeleton-table-filter" />
                ))}
            </div>
            </div>
            <hr/>
        </>
      )}
      <div className="table-container">
        <table className="skeleton-table">
          {hasHeader && (
            <thead>
              <tr>
                {columnIndexes.map((_, colIndex) => (
                  <th key={`header-${colIndex}`}>
                    <div className="line" />
                  </th>
                ))}
              </tr>
            </thead>
          )}
          <tbody>
            {rowIndexes.map((_, rowIndex) => (
              <tr key={`row-${rowIndex}`}>
                {columnIndexes.map((_, colIndex) => (
                  <td key={`cell-${rowIndex}-${colIndex}`}>
                    <div className="line" />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SkeletonTable;
